import api from '@/api.js';
const state = {
    items: [],
    draw: {},
    sim: {}
};
const mutations = {
    list(state, items) {
        state.items = items;
    },
    drawing(state, draw) {
        state.draw = draw;
    },
    sim(state, sim) {
        state.sim = sim;
    }
};
const getters = {
    items: (state) => state.items,
    draw: state => state.draw,
    simulated: state => state.sim
};
const actions = {
    async list({ commit }) {
        const res = await api.eurojackpot.list();
        commit('list', res.data);
    },
    async drawing({ commit }, date) {
        console.log('DRAWING', date);
        const resp = await api.eurojackpot.drawing(date);
        commit('drawing', resp.data);
    },
    async simulation({ commit }, cfg) {
        const resp = await api.eurojackpot.simulation(cfg);
        commit('sim', resp.data);
    }
};
export const Eurojackpot = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
